/* eslint-disable max-len */
/* eslint-disable consistent-return */
/* eslint-disable array-element-newline */
import React, {useEffect, useRef, useState} from "react";
import AddressInfoContainer from "./AddressInfoContainer";
import BillingInfoEdit from "./BillingInfoEdit";
import Cart from "./Cart";
import CartAPI from "../../shared/modules/CartAPI";
import CartHelper from "../../shared/modules/CartHelper";
import CustomModal from "../../shared/components/CustomModal";
import Notification from "../../shared/components/Notification";
import PropTypes from "prop-types";
import {withCookies} from "react-cookie";

const CartModal = ({cookies, handleCloseCartModal, handleDisplayPurchaseNotification, isCartModalOpen, recurlyPublicKey}) => {
  const [isBillingInfoEdit, setIsBillingInfoEdit] = useState(false);
  const [isShippingEdit, setIsShippingEdit] = useState(false);
  const [cartInfo, setCartInfo] = useState(null);
  const [billingInfo, setBillingInfo] = useState(null);
  const [shippingInfo, setShippingInfo] = useState(null);
  const [loadingPage, setLoadingPage] = useState(true);
  const [promoCode, setPromoCode] = useState(cookies.get("auto_applied_promo_code"));

  const [error, setError] = useState(null);
  const [displayErrors, setDisplayErrors] = useState(false);

  const [notificationText, setNotificationText] = useState(null);

  const [retailItemAvailability, setRetailItemAvailability] = useState({});
  const [clearanceItemAvailability, setClearanceItemAvailability] = useState({});

  const modalRef = useRef(null);

  useEffect(() => {
    const handleClick = () => {
      setDisplayErrors(false);
      setError(null);
    };

    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);

  const setProductDescriptorAvailability = (retailItems, clearanceItems) => {
    const retailPdIds = retailItems.map(item => item.product_descriptor.id);
    const clearancePdIds = clearanceItems.map(item => item.product_descriptor.id);

    if (retailPdIds.length > 0) {
      CartAPI.fetchPDAvailability(retailPdIds, "retail").then((response) => {
        setRetailItemAvailability(response);
      });
    }

    if (clearancePdIds.length > 0) {
      CartAPI.fetchPDAvailability(clearancePdIds, "clearance").then((response) => {
        setClearanceItemAvailability(response);
      });
    }
  };

  const handleBillingInfo = (billingInformation) => {
    setBillingInfo(CartHelper.toCamelCase(billingInformation));
  };

  useEffect(() => {
    CartAPI.getCartInfo(promoCode).then((response) => {
      handleBillingInfo(response.billing_info);
      setShippingInfo(response.shipping_info);
      setCartInfo(response.preview);
      setLoadingPage(false);
      setProductDescriptorAvailability(response.preview?.cart_items_by_sku_and_kind.retail_items || [],
        response.preview?.cart_items_by_sku_and_kind.retail_items || []);
    });
  }, [isShippingEdit, isBillingInfoEdit]);

  useEffect(() => {
    if (notificationText) {
      const timeout = setTimeout(() => {
        setNotificationText(null);
      }, 6000);
      return () => {
        clearTimeout(timeout);
      };
    }
  }, [notificationText]);

  useEffect(() => {
    if (cartInfo && cartInfo.cart_promos.length > 0) {
      setPromoCode(cartInfo.cart_promos[0].promo_code);
    }
  }, [cartInfo]);

  return (
    <CustomModal
      handleCloseModal={handleCloseCartModal}
      modalClassName="cart-modal"
      ref={modalRef}
      show={isCartModalOpen}
    >
      {
        displayErrors && error &&
        <div className="cart-modal-error">
          {error.message ? error.message : "There was an error updating your information."}
        </div>
      }
      {!isShippingEdit && !isBillingInfoEdit &&
        <Cart
          billingInfo={billingInfo}
          cartInfo={cartInfo}
          clearanceItemAvailability={clearanceItemAvailability}
          handleCloseCartModal={handleCloseCartModal}
          handleDisplayPurchaseNotification={handleDisplayPurchaseNotification}
          loadingPage={loadingPage}
          promoCode={promoCode}
          retailItemAvailability={retailItemAvailability}
          setCartInfo={setCartInfo}
          setIsBillingEdit={setIsBillingInfoEdit}
          setIsShippingEdit={setIsShippingEdit}
          setNotificationText={setNotificationText}
          setPromoCode={setPromoCode}
          shippingInfo={shippingInfo}
        />
      }
      {isShippingEdit &&
        <AddressInfoContainer
          addressInfo={shippingInfo}
          isShipping
          modalRef={modalRef}
          setAddressInfo={setShippingInfo}
          setDisplayErrors={setDisplayErrors}
          setError={setError}
          setIsEditingAddress={setIsShippingEdit}
        />
      }
      {isBillingInfoEdit &&
        <BillingInfoEdit
          customerInfo={billingInfo.name}
          recurlyPublicKey={recurlyPublicKey}
          setDisplayErrors={setDisplayErrors}
          setError={setError}
          setIsBillingInfoEdit={setIsBillingInfoEdit}
        />
      }
      {notificationText && <Notification notificationDisplayText={notificationText} />}
    </CustomModal>
  );
};


CartModal.propTypes = {
  "cookies": PropTypes.object.isRequired,
  "handleCloseCartModal": PropTypes.func.isRequired,
  "handleDisplayPurchaseNotification": PropTypes.func.isRequired,
  "isCartModalOpen": PropTypes.bool.isRequired,
  "recurlyPublicKey": PropTypes.string.isRequired
};

export default withCookies(CartModal);
